import { render, staticRenderFns } from "./WebUIText.vue?vue&type=template&id=1aff09b4&"
import script from "./WebUIText.vue?vue&type=script&lang=js&"
export * from "./WebUIText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports